'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var zh_TW = {
  // pay
  www_title: '日曆清單',
  www_homepage: '官網首頁',
  www_keywords: '日曆清單,日曆,goodnote,備忘錄,農民曆,萬年曆,日記,紀念日,筆記本,月曆,打卡,倒數日,note,行程規劃,行程,提醒,倒數計時,筆記,日記本,日程表,時間管理,待辦,清單,便簽,小日常,通知,日程',
  www_description: '可以透明的顯示在桌面壁紙上，提供農曆、節氣、節假日、法定假日顯示。雙擊即可編輯記錄瑣事、日程安排、重複任務等。支持多端同步數據，實時共享數據，團隊協作。',
  update_log: '',
  more_function: '更多功能介紹',
  slogan_text1: '可以透明的顯示在桌面壁紙上，提供農曆、節氣、節假日、法定假日顯示。 ',
  slogan_text2: '雙擊即可編輯記錄瑣事、日程安排、重複任務等。 ',
  slogan_text3: '支持多端同步數據，實時共享數據，團隊協作。 ',
  slogan_h5: '電腦版本可以透明的顯示在桌面壁紙上，提供農曆、節氣、節假日、法定假日顯示。雙擊即可編輯記錄瑣事、日程安排、重複任務等，還可以微信提醒。支持多端同步數據，實時共享數據，團隊協作。',
  android_download: '下載APP',
  ios_download: 'AppStore安裝',
  support_system: '已支持如下平台',
  windows_button: 'Windows版',
  mac_button: 'Mac版',
  linux_button: 'Linux版本',
  linux_op_x86: 'X86 版本',
  linux_op_arm64: 'ARM64 版本',
  iphone_button: 'iPhone版',
  android_button: '安卓版',
  scan_download_phone: '掃描二維碼下載手機客戶端',
  content_title1: '實時同步數據、協同辦公',
  content_text1: '可以在PC電腦、Mac電腦、手機之間實時同步您的日程安排\n如果您是一個小團隊，還可以實現團隊協同辦公',
  content_title2: '透明顯示在桌面壁紙上',
  content_text2: '可以直接釘在桌面壁紙上，按快捷鍵即可返回到桌面編輯查看您的日程安排和日曆信息',
  content_title3: '重複事件',
  content_text3: '重要的紀念日、信用卡還款、學生的課程等可以設置重複任務顯示在日曆上',
  content_title4: '總有一種日曆是您想要的',
  content_text4: '無論您的從事行業是白領、學生、教師、IT、政府機構、金融，強大的日曆設置功能，總能滿足您的需求',
  support: '客戶支持',
  support_title: '日曆清單-客戶支持',
  support_text1: '如果您有任何意見和建議，敬請郵件聯繫我們\nservice@xiaoweiyunfu.com',
  support_text2: '',
  help: '',
  pay_title: '日曆清單-功能介紹',
  cata_basic_intro_title: '功能介紹',
  cata_basic_intro_title1: '多端資料同步（手動）',
  basic_intro_title1: '多端資料同步',
  basic_intro_subtitle1: '無論您使用的是手機、電腦或iPad，都可以輕鬆同步資料。 ',
  basic_intro_text1: '您需要在同步的裝置上使用相同的帳號登入。 <p class="p" /><font color="#FE776D">哪個裝置有數據，就需要在哪個裝置上點擊雲端按鈕手動同步數據，這時候剛才記錄的數據就在其他的裝置上顯示了。 </font><p class="p" />我們提供了自動同步功能。 開啟自動同步後，您的資料將自動在裝置之間進行同步，無需手動點擊。 ',
  cata_basic_intro_title2: '日曆備忘',
  basic_intro_title2: '日曆備忘',
  basic_intro_subtitle2: '以日曆的方式記錄瑣事，簡潔而不簡單。 ',
  basic_intro_text2: '您可以在日曆上雙擊任何一個日期，即會彈出一個編輯框，您記錄瑣事。 <p class="p" />回車換到新行就可以記錄新的任務。 ',
  cata_basic_intro_title3: '提醒',
  basic_intro_title3: '提醒',
  basic_intro_subtitle3: '不容錯過任何重要的事情，您可以添加提醒來即時提醒自己。 ',
  basic_intro_text3: '點選編輯框下方的提醒按鈕，可以新增提醒。 <p class="p" />提醒功能支援強大的個人化設置，您可以定義重複類型、結束日期、提醒次數和提醒時間等。 ',
  cata_basic_intro_title4: '倒數日',
  basic_intro_title4: '倒數日',
  basic_intro_subtitle4: '不能忘記每個重要的日子，您可以設定倒數日來提醒自己。 ',
  basic_intro_text4: '點選編輯框下方的倒數日按鈕，可以加倒數日。 <p class="p" />我們將倒數日分為五個類別(生日、節日、紀念日、考試和預設)，並為您製作了精美的倒數日卡片，以便您更方便地提醒自己。 ',
  cata_basic_intro_title5: '任務標記完成',
  basic_intro_title5: '任務標記完成',
  basic_intro_subtitle5: '一鍵勾選完成，讓您更有成就感地完成每個任務。 ',
  basic_intro_text5: '點選編輯第一個按鈕，標記為完成。 ',
  cata_basic_intro_title6: '搜尋',
  basic_intro_title6: ' 搜尋 ',
  basic_intro_subtitle6: '您可以使用搜尋功能，搜尋記錄。 ',
  basic_intro_text6: '點選日曆右上方的選單列按鈕，選擇搜尋。 <p class="p" />在搜尋欄中輸入需要尋找的關鍵字，系統會篩選出符合條件的行程安排，並顯示在搜尋欄下方。 <p class="p" />雙擊搜尋結果中的任何一個行程，即可進入編輯頁面，對該日程進行修改。 ',
  cata_basic_intro_title7: '重複任務',
  basic_intro_title7: '重複任務',
  basic_intro_subtitle7: '如果有經常重複的日程，可以輕鬆設定重複任務。 ',
  basic_intro_text7: '在編輯框中，點選重複任務按鈕。 根據您的需求選擇相應的重複時間和重複類型。 ',
  cata_basic_intro_title8: '教學週',
  basic_intro_title8: '教學週',
  basic_intro_subtitle8: '對於學生黨和教師們，我們提供了顯示教學週的功能。 ',
  basic_intro_text8: '點擊日曆右上角菜單按鈕再點擊設置，然後在設置對話框中選擇高級，最後將當前學期所在的周數設置為“第一周”，這樣日曆左側的周數就會顯示為教學 週。 ',
  cata_basic_intro_title9: '日曆文字大小調整',
  basic_intro_title9: '日曆文字大小調整',
  basic_intro_subtitle9: '可以設定日曆介面字型、文字大小和文字顏色。 ',
  basic_intro_text9: '點擊日曆右上角選單按鈕再點擊設置，然後在設定對話框選擇日曆，最後配置日曆字體、大小和顏色。 ',
  cata_basic_intro_title10: '記錄內容文字大小調整',
  basic_intro_title10: '記錄內容文字大小調整',
  basic_intro_subtitle10: '儲存格內的文字可以調整大小、字型和顏色。 ',
  basic_intro_text10: '點擊日曆右上角選單按鈕再點選設置，然後在設定對話框選擇日單元格，最後配置日曆字體、大小和顏色。 ',

  //便签
  cata_basic_intro_title11: "便簽",
  basic_intro_title11: "便簽",
  basic_intro_subtitle11: "配備簡潔易用的便簽功能。",
  basic_intro_text11: "點擊日曆右上角插件按鈕，即可看見便簽相關功能，可新建便簽或對便簽進行設置。",

  // 课程表
  cata_basic_intro_title12: '課程表',
  basic_intro_title12: '課程表',
  basic_intro_subtitle12: '配備功能完善的課程表功能。',
  basic_intro_text12: '點擊日曆右上角插件按鈕，即可看見課程表功能，可新建課程表或對課程表進行設置。',

  // 2024-09-26 新增独家介绍
  exclusive_title: '獨家',
  cata_basic_intro_new_title0: "零廣告",
  basic_intro_new_subtitle0: "我們堅信，無廣告才是真效率",
  basic_intro_new_text0: "無論您是尊貴的付費用戶還是免費用戶，無論您在哪種平台上操作，日曆清單都無任何廣告侵擾，純淨陪伴。",

  cata_basic_intro_new_title1: "透明貼在桌面壁紙上",
  basic_intro_new_subtitle1: "與系統桌面和壁紙無縫融合，桌面操作無阻",
  basic_intro_new_text1: "您在使用日曆的同時，不影響滑鼠對桌面的文件、圖標的操作。",

  cata_basic_intro_new_title2: "跨月顯示（即浮動的月份）",
  basic_intro_new_subtitle2: "可跨月顯示日曆，不管是月初月底，均可看見前後一週或兩週的日程",
  basic_intro_new_text2: "點擊日曆右上角的小箭頭選單，進入設置，在 日曆 - 顯示 中即可切換跨月顯示或完整顯示月份",

  cata_basic_intro_new_title3: "隱藏休息日",
  basic_intro_new_subtitle3: "可隱藏休息日，讓您專注於工作日",
  basic_intro_new_text3: "點擊日曆右上角的小箭頭選單，進入設置，在 進階 - 每週休息日 中， 可自定義休息日及設置休息日是否顯示。",

  cata_basic_intro_new_title4: "行、列數自定義",
  basic_intro_new_subtitle4: "可自定義行列數，打造專屬日曆視圖",
  basic_intro_new_text4: "點擊日曆右上角的小箭頭選單，進入設置，在 日曆 - 顯示 中， 自定義要顯示的行數及列數，即可只顯示幾週或只顯示每週的某幾天",

  cata_basic_intro_new_title5: "全系統支援",
  basic_intro_new_subtitle5: "Windows/Android/iOS/Mac/Linux全支援",
  basic_intro_new_text5: "iOS/Mac用戶可在AppStore搜尋「日曆清單」下載安裝。 <p /> Android用戶可在Google Play搜尋「日曆清單」下載安裝。<p />Windows/Linux用戶可在<a href='/'>官網首頁</a>下載。",

  group_intro_title1: '輕鬆分享您的行程',
  group_intro_subtitle1: '如果您是幾人或幾十人的小團隊，想和您的團隊成員分享並管理日程，您可以試試日曆清單的團隊功能。 ',
  group_intro_text1: '點擊日曆右上角的個人按鈕，然後選擇「帳戶設定」，再選擇「共享團隊」，最後在頁面的右上角可以添加您的成員。 <p class="p" />為了方便您的管理，團隊成員只能透過信箱的方式新增。 ',
  group_intro_title2: '團隊成員之間日程不共享',
  group_intro_subtitle2: '只想讓團隊成員看到編輯自己的任務和日程，團隊成員之間互相不影響。 ',
  group_intro_text2: '在「帳戶設定」裡點選「子帳號」，然後加入子帳號。 <p class="p" />然後在「帳戶設定」裡點擊「共享團隊」，在子帳號顯示控制欄裡為團隊成員選擇對應的子帳號。 ',
  group_intro_title3: '團隊成員不可編輯',
  group_intro_subtitle3: '當您只需共用日程，不想讓團隊成員編輯，可以設定為團隊成員為唯讀。 ',
  group_intro_text3: '在「帳戶設定」裡點選「共享團隊」，找到對應的成員勾選只讀，最後儲存。 ',
  group_intro_title4: '方便查看所有會員的行程',
  group_intro_subtitle4: '您可以一目了然的查看所有成員的日程。 ',
  group_intro_text4: '在子帳號選單裡選擇「主帳號(顯示所有成員內容)」<p class="p" />如果成員的顯示的內容過多，可以將滑鼠移到日期上面，會顯示完成的提示 。 ',

  pay_new_upgrade_txt1: '只需使用相同的賬號在其他設備上登錄，數據即可立即同步顯示，無需任何其他操作。',
  pay_new_upgrade_txt2: '不僅如此，爲了確保您的歷史數據安全，服務器也會同時備份您的歷史數據。<p class="p" />打開編輯框，點擊編輯框最後一個按鈕，便可以查看所有的歷史和相應的功能。',
  pay_new_upgrade_txt3: '點擊日曆右上角的個人按鈕，然後選擇「賬戶設置」，再選擇「子賬號」',
  pay_new_upgrade_txt4: '自動延期功能會獲取前三天未完成的任務，並將它們延期到下一天。當任務被連續延期到第7天時，此功能會自動停止，不再繼續延期任務。<p class="p" />延期的任務後面會標註「（9-10）」，代表是從哪個月哪一天開始自動延期的。<p class="p" />勾選完成後，任務將不再自動延期。',
  pay_new_upgrade_txt5: '',
  pay_new_upgrade_txt6: '點擊「賬戶設置」，然後再點擊「在線設備」。',
  pay_new_upgrade_txt7: '免費用戶會有2個登入客戶端的限制。',
  pay_new_upgrade_txt8: '免費用戶雲端僅存儲最近6個月的數據。',
  pay_new_upgrade_txt9: '',
  cata_pay_new_upgrade_title: 'VIP會員功能',
  cata_pay_new_upgrade_title1: '多端即時同步資料（自動）',
  cata_pay_new_upgrade_title2: '歷史記錄自動備份，檢視與刪除',
  cata_pay_new_upgrade_title3: '子帳號功能',
  cata_pay_new_upgrade_title4: '未完成任務自動延期',
  cata_pay_new_upgrade_title5: '任意地方登入同步數據',
  cata_pay_new_upgrade_title6: '在線設備查看',
  cata_pay_new_upgrade_title7: '不限客戶端登錄數量',
  cata_pay_new_upgrade_title8: '雲端永久存儲數據',
  cata_pay_new_upgrade_title9: 'VIP專屬客服',
  pay_new_upgrade_title1: '多個設備之間即時同步數據',
  pay_new_upgrade_title2: '歷史記錄功能',
  pay_new_upgrade_title3: '子賬號功能',
  pay_new_upgrade_title4: '未完成任務自動延期',
  pay_new_upgrade_title5: '任意地方登入同步數據',
  pay_new_upgrade_title6: '在線設備查看',
  pay_new_upgrade_title7: '不限客戶端登錄數量',
  pay_new_upgrade_title8: '雲端永久存儲數據',
  pay_new_upgrade_title9: 'VIP專屬客服',
  pay_new_upgrade_subtitle1: '您可以在手機、電腦、iPad等多種設備之間實現即時同步數據',
  pay_new_upgrade_subtitle2: '歷史記錄將自動備份、查看和刪除。',
  pay_new_upgrade_subtitle3: '當您在一天內記錄了過多的任務時，您可以按照工作、生活等分類將它們分開顯示。',
  pay_new_upgrade_subtitle4: '如果您在一天內記錄了過多的任務並且沒有完成，系統將自動將這些任務延期到下一天。',
  pay_new_upgrade_subtitle5: '可以在家裡、公司、学校、任何地方，多台電腦之間即時同步數據。',
  pay_new_upgrade_subtitle6: '在線設備管理，可以查看當前在線的客戶端設備，並可操作當前顯示的設備退出登錄。',
  pay_new_upgrade_subtitle7: '同一個賬號，不限制登錄客戶端設備的個數，並可以在家、公司、任何地方登錄。',
  pay_new_upgrade_subtitle8: '會員用戶數據將永久存儲在雲端，更換設備無憂，只需登入帳號即可獲取所有數據。',
  pay_new_upgrade_subtitle9: '會員使用中有任何問題，聯系客服時將由專屬客服優先為您解决。',

  pay_payment_method: '支付方式',
  pay_payment_wechat: '微信支付',
  pay_payment_paypal: 'PayPal',
  pay_upgrade_button: '立即升級',
  pay_upgrade_renew_button: '續費',
  pay_forpay_left: '為"',
  pay_forpay_right: '"支付',
  pay_payment_unit: 'USD',
  pay_three_month: '三个月',
  pay_one_year: '一年',
  pay_three_year: '三年',
  pay_original_price_threemonth: '原價 4 USD',
  pay_original_price_oneyear: '原價 16 USD',
  pay_original_price_threeyear: '原價 48 USD',
  pay_application: '日曆清單',

  cata_team_intro_title1: '輕鬆共享您的日程',
  cata_team_intro_title2: '查看團隊成員的日程',
  cata_team_intro_title3: '只讀權限',

  cata_user: '免費用戶',
  cata_vip: 'VIP會員',
  cata_vip_team: 'VIP共享團隊',

  group_upgrade_button: '立即升級團隊VIP',
  group_title: '日曆清單 - 分享團隊版本',

  about_us: '',
  copy_right: 'Copyright © 2018 - 現在',

  wapper_title: "免費壁紙皮膚",
  wapper_desc_html: "<p>您使用的是Windows Store下載的安裝程序，因為權限的問題，沒有壁紙皮膚功能。</p><p class='red'> 想要使用此功能，請提前登陸並同步備份數據，然後卸載Windows Store版本。 在<a href='/'>這裡下載</a>最新的安裝包並安裝。</p>",

  v2_slogan_text: "您的專屬時間管理專家",
  v2_feature_title: "透明顯示<span class=\"gap\">|</span>多端數據同步<span class=\"gap\">|</span>便簽<span class=\"gap\">|</span>倒數紀念日<span class=\"gap\">|</span>日程提醒",
  v2_feature_title_baseintro: "透明顯示<span class=\"gap\"></span>多端數據同步<span class=\"gap\"></span>便簽<span class=\"gap\"></span>倒數紀念日<span class=\"gap\"></span>日程提醒",
  v2_content_title_note: "便簽",
  v2_content_title_noad: "零廣告",
  v2_content_text_note: "規劃有序更高效，自選顏色隨心配",
  v2_content_text_noad: "全渠道無廣告干擾，享受純淨體驗",

  v2_content_title_reminder: "通知提醒",
  v2_content_text_reminder: "可自定義重複、複雜的任務和提醒。",

  v2_content_title_countdown: "倒數紀念日卡片",
  v2_content_text_countdown: "直接在桌面上顯示精美的卡片，不忘記每一個重要的日子。",

  v2_scan: "掃一掃",
  v2_down_phone: "免費下載手機App",

  v2_update_time: "更新時間",
  v2_update_ver: "最新版本",
  v2_feature_other: "其他特色功能",
  v2_feature_other_1_title: "個性化設置",
  v2_feature_other_1_html: "<li>日曆上可顯示農曆、節氣、節假日、法定假日</li><li>任意一天都可以設置您想要的背景顏色</li><li>自定義重複任務，可按天、週、月、年隨心設置</li>",
  v2_feature_other_2_title: "智能化功能",
  v2_feature_other_2_html: "<li>新增任務只需要回車，極簡設計才是真正的效率</li><li>浮動日曆設計，一眼就可以查看上、下週的任務</li><li>任務標記完成後，會自動移動到任務的末尾</li><li>雲端自動備份歷史數據，輕鬆查看歷史記錄</li><li>未完成任務可以自動延期到第二天</li>",
  v2_feature_other_3_title: "特色功能",
  v2_feature_other_3_html: "<li>導出Excel(PC電腦端)，可以整理一年的計劃</li><li>搜索功能，快速查找記錄過重要的任務</li><li>教學周設置，專為老師和學生設計</li><li>子賬號，可以將您的工作、學習的任務分開記錄</li><li>在線設備查看，並可以操作設備下線</li><li>小團隊版本，可多人團隊共享您的日曆日程</li>",

  v2_about_us: "關於我們",

  v2_feature_exclusive_text: "獨家功能",
  v2_feature_vip_text: "會員功能",
  v2_feature_normal_text: "基礎功能",
  v2_feature_team_text: "團隊功能",

  v2_ver_free_title: "免費版",
  v2_ver_free_desc: "適合個人本地使用",
  v2_ver_vip_title: "會員版",
  v2_ver_vip_desc: "適合個人使用，多設備同步更方便",
  v2_ver_team_title: "團隊版",
  v2_ver_team_desc: "適合中小團隊多人合作使用",

  v2_ver_free_equity: "包含功能:",
  v2_ver_vip_equity: "包含免費版全部功能，並額外提供:",
  v2_ver_team_equity: "包含免費版、會員版全部功能，並額外提供:",

  v2_ver_equity_support: "支援",
  v2_ver_include_base: "包含基礎功能",
  v2_ver_include_vip: "包含會員功能",

  v2_down_btn_text: "立即免費下載",

  v2_sub_title: "拒絕拖延 效率人生",
  v2_www_link: "官網首頁",
  v2_pay_btn_text: "立即升級",
  v2_team_days_desc: "10人每年",
  v2_team_btn: "查看團隊版本"

};

exports["default"] = zh_TW;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./lang/zh_TW.js
// module id = 304
// module chunks = 0